import { render, staticRenderFns } from "./TUDP.vue?vue&type=template&id=7fcba1d8&scoped=true&"
import script from "./TUDP.vue?vue&type=script&lang=ts&"
export * from "./TUDP.vue?vue&type=script&lang=ts&"
import style0 from "./TUDP.vue?vue&type=style&index=0&id=7fcba1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcba1d8",
  null
  
)

export default component.exports